// pagina afisata cand userul apasa logout
import "../../css/style.css";
import theme from "../../css/theme";

import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import axios from "axios";

const Logout = () => {
    const returnHome = useNavigate();

    const onLogout = () => {
        axios.get("/api/public/logout")
            .catch(error => {
                console.error(`Logout error`, error);
            })
            .finally(() => {
                returnHome("/");
            })
    }

    return (
        <div className="edit-member-container logout-page">
            <p> Ai alunecat ... </p>
            <Button
                className="admin-buttons"
                variant="contained"
                theme={theme}
                type="button"
                onClick={onLogout}
            > Acasa </Button>
        </div >
    );
}
export default Logout;